module.exports = __webpack_public_path__ + "img/trash_outlined_64.b52b5ca1.svg";